import Api from '@/helpers/api';
/**
 * Obtiene la lista de grupos
 *
 * @returns {Promise<Group>} Promise - una promesa con la lista de grupos // Error
 */
const getAllGroups = async () => {
    const result = await Api.get('/groups');
    return result.data;
};

/**
 * Obtiene un grupo, por su ID.
 *
 * @param {string} id - el Id del grupos
 * @returns {Promise<Group>} Promise una promesa con el estado del servicio // Error
 */
const getOneGroup = async (id) => {
    const result = await Api.get(`/groups/${id}`);
    return result.data;
};

/**
 * Guarda un grupo
 *
 * @param {object} group - un objeto con los datos del grupo a guardar
 * @returns {Promise<Group>} Promise - una promesa con el estado del servicio // Error
 */
const saveGroup = async (group) => {
    const result = await Api.post('/groups', group);
    return result.data;
};

/**
 * Actualiza un grupo
 *
 * @param {string} id - el Id del grupo
 * @param {object} group - un objeto con los datos del grupo a actualizar
 * @returns {Promise<Group>} Promise - una promesa con el estado del servicio // Error
 */
const updateGroup = async (id, group) => {
    const result = await Api.put(`/groups/${id}`, group);
    return result.data;
};

/**
 * Elimina un grupo
 *
 * @param {string} id - el Id del grupo
 * @returns {Promise<Group>} Promise - una promesa con el estado del servicio // Error
 */
const deleteGroup = async (id) => {
    const result = await Api.delete(`/groups/${id}`);
    return result.data;
};


export {
    getAllGroups,
    getOneGroup,
    saveGroup,
    updateGroup,
    deleteGroup
};
